import type { AxiosInstance, AxiosResponse } from 'axios';
import type { Filter } from '@/models/common';
import type { RootResponse } from '@/models/rootResponse';
import type { User } from '@/models/users';

export type GetUsers = {
   page: number;
   search?: string;
   filters?: Filter[];
};

class UserService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getCurrentUser(): Promise<User> {
      const response: AxiosResponse<RootResponse<User>> =
         await this.provider.get(`/users/current-user`);

      return response.data.data;
   }

   async getUsers({
      page,
      search,
      filters,
   }: GetUsers): Promise<RootResponse<User[]>> {
      const response: AxiosResponse<RootResponse<User[]>> =
         await this.provider.post(`/rest/users/search`, {
            search: {
               text: {
                  value: search ?? '',
               },
               sorts: [
                  {
                     field: 'lastname.keyword',
                     direction: 'asc',
                  },
               ],
               ...(filters ? { filters } : {}),
               page: page,
            },
         });

      return response.data;
   }
}

export default UserService;
